module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "active has-popover"
  }, [_c('a', {
    attrs: {
      "href": "./products.html"
    }
  }, [_vm._v("PRODUCTS")]), _vm._v(" "), _c('div', {
    staticClass: "popover bottom",
    attrs: {
      "id": "productPopover"
    }
  }, [_c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "popover-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "popover-products-wrapper"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "./products.html#smartAPP"
    }
  }, [_vm._v(_vm._s(_vm.t('smartAPP')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./products.html#cashierAggregator"
    }
  }, [_vm._v(_vm._s(_vm.t('cashierAggregator')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./products.html#visibleDashboard"
    }
  }, [_vm._v(_vm._s(_vm.t('visibleDashboard')))])])]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "./products.html#elitePOS"
    }
  }, [_vm._v(_vm._s(_vm.t('elitePOS')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./products.html#embraceCapability"
    }
  }, [_vm._v(_vm._s(_vm.t('embraceCapability')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./products.html#beyondImagin"
    }
  }, [_vm._v(_vm._s(_vm.t('beyondImagination')))])])])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('language-switch', {
    attrs: {
      "id": "languageSwitch"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "./"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/images/logo.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popover-product-new"
  }, [_c('a', {
    attrs: {
      "href": "./docode.html"
    }
  }, [_vm._v("DOCODE"), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("NEW")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "./start.html"
    }
  }, [_vm._v("HOW TO START")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "./about.html"
    }
  }, [_vm._v("ABOUT US")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26809a4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigator.vue
// module id = 34
// module chunks = 1 2 3 4 5 6